var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHackerrank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x31_60-hackerrank"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M454.843,141.001c-13.019-22.417-172.832-115-198.859-115c-26.019,0-185.895,92.351-198.84,115     c-12.947,22.649-13.019,207.358,0,230.009c13.018,22.639,172.839,114.989,198.84,114.989c26,0,185.841-92.466,198.851-114.999     C467.842,348.467,467.851,163.417,454.843,141.001z M309.862,398.15c-3.559,0-36.756-32.137-34.141-34.762     c0.781-0.78,5.625-1.328,15.768-1.644c0-23.564,0.53-61.622,0.844-77.553c0.038-1.814-0.395-3.081-0.395-5.256h-71.812     c0,6.379-0.412,32.523,1.232,65.479c0.205,4.078-1.42,5.353-5.158,5.335c-9.102-0.025-18.211-0.099-27.321-0.071     c-3.683,0.009-5.274-1.374-5.157-5.488c0.826-30.043,2.66-75.488-0.134-191.07v-2.849c-8.688-0.314-14.717-0.862-15.508-1.652     c-2.624-2.624,31.032-34.76,34.581-34.76c3.558,0,36.989,32.145,34.383,34.76c-0.782,0.781-7.098,1.338-15.067,1.652v2.84     c-2.174,23.135-1.823,71.506-2.362,94.686h72.107c0-4.089,0.351-31.212-1.077-75.145c-0.091-3.047,0.853-4.646,3.781-4.672     c9.945-0.072,19.9-0.117,29.855-0.055c3.108,0.019,4.105,1.546,4.043,4.834c-3.28,171.861-0.594,159.867-0.594,188.975     c7.97,0.315,15.112,0.864,15.895,1.655C346.213,366.004,313.42,398.15,309.862,398.15L309.862,398.15z",
    style: {
      fill: "#00B760"
    }
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHackerrank);
export default __webpack_public_path__ + "static/media/Hackerrank.36573fe42a39c001928602295029bee3.svg";
export { ForwardRef as ReactComponent };